module.exports = __webpack_public_path__ + "img/widget_0150.a95f9b5f.png";